import { render, staticRenderFns } from "./NewUserTerms.vue?vue&type=template&id=0499ebdf&scoped=true&"
import script from "./NewUserTerms.vue?vue&type=script&lang=js&"
export * from "./NewUserTerms.vue?vue&type=script&lang=js&"
import style0 from "./NewUserTerms.vue?vue&type=style&index=0&id=0499ebdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0499ebdf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCheckbox,VDialog,VIcon,VLayout,VSnackbar,VSpacer})
